<template>
  <span v-if="timeLeft!==0" class="timer" id="countdown">
    <!-- Time ended -->
    <span v-if="timeLeft<0">
      {{ $t('filter.completed') }}
    </span>

    <!-- Time running -->
    <span v-else class="timer-value">
      <template v-if="days > 0">
        {{ days | formatTime }}<span class="timer-unit">j</span>
      </template>

      <template v-if="hours > 0">
        {{ hours | formatTime }}<span class="timer-unit">h</span>
      </template>

      <template v-if="isLong || days === 0">
        {{ minutes | formatTime }}<span class="timer-unit">m</span>
      </template>

      <template v-if="isLong || hours === 0">
        {{ seconds | formatTime }}<span class="timer-unit">s</span>
      </template>
    </span>
  </span>
</template>

<script>
export default {
  name: "TimerSimpleLong",
  props: {
    timeLeft: {
      type: Number,     // seconds remaining at component creation
      required: true,
    },
    isLong: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      elapsed: 0,              // milliseconds elapsed since mounted
      timerInterval: null,
      startTime: null,         // timestamp when countdown started
    };
  },
  computed: {
    initialTimeLeft() {
      return this.timeLeft;
    },
    remainingMs() {
      if (this.initialTimeLeft <= 0) return 0;
      return Math.max(0, this.initialTimeLeft * 1000 - this.elapsed);
    },
    ended() {
      return this.initialTimeLeft > 0 && this.remainingMs === 0;
    },
    seconds() {
      return Math.floor((this.remainingMs / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.remainingMs / (1000 * 60)) % 60);
    },
    hours() {
      return Math.floor((this.remainingMs / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.remainingMs / (1000 * 60 * 60 * 24));
    },
  },
  methods: {
    updateElapsed() {
      if (this.startTime === null) {
        this.startTime = Date.now();
      }
      this.elapsed = Date.now() - this.startTime;
    },
  },
  mounted() {
    if (this.initialTimeLeft > 0) {
      this.startTime = Date.now();
      this.timerInterval = setInterval(this.updateElapsed, 1000);
    }
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  filters: {
    formatTime(value) {
      return value < 10 ? "0" + value : value;
    },
  },
};
</script>

<style scoped>
.timer {
  display: inline;
}

.timer-value {
  font-weight: bold;
  display: inline;
}

.timer-value > * + * {
  margin-left: 0.5rem;
}

.timer-unit {
  font-weight: normal;
  margin-left: 0.15rem;
}
</style>